var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useHasReactRouterContext from '../../../hooks/useHasReactRouterContext';
export default function ButtonLink(_a) {
    var { children, href, target = undefined } = _a, rest = __rest(_a, ["children", "href", "target"]);
    const hasReactRouterContext = useHasReactRouterContext();
    if (/^(https?:\/\/)/.test(href) || !hasReactRouterContext) {
        return (React.createElement("a", Object.assign({ style: { textDecoration: 'none' }, href: href, target: target }, rest, { rel: target === '_blank' ? 'noopener noreferrer' : '' }), children));
    }
    return (React.createElement(RouterLink, Object.assign({ style: { textDecoration: 'none' }, to: href, target: target }, rest), children));
}
